import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import InventoryWrapper from './Inventory.styles';
import IntlMessages from '@iso/components/utility/intlMessages';
import { useRouteMatch } from 'react-router-dom';
import inventoryAction from '@iso/redux/inventory/actions';
import trxAction from '@iso/redux/transactions/actions';
import loadingLogo from '@iso/assets/images/payment_transaction_logo/logo_anim.svg';
import headerLogo from '@iso/assets/images/biz/logo_rgb.svg';
import moment from 'moment-timezone';
// import headerLogo from '@iso/assets/images/biz/paybiz_logo.png';
// import imageBanner from '@iso/assets/images/test_inventory/banner.jpg';
// import image1 from '@iso/assets/images/test_inventory/image1.jpg';
// import image2 from '@iso/assets/images/test_inventory/image2.jpg';
// import image3 from '@iso/assets/images/test_inventory/image3.jpg';
import footerLogo from '@iso/assets/images/payment_transaction_logo/footer_pnx_logo.svg';
import { Button, Form, Input, message, Typography, Table, Empty, Carousel, notification,Select,DatePicker } from 'antd';
// import Spin from './Spin.styles';
import ItemNotFound from './ItemNotFound';
// import TransactionListItem from '@iso/components/generic/TransactionListItem/TransactionListItem';
import ErrorHolder from './ErrorHolder';
import { DisconnectOutlined, WifiOutlined } from '@ant-design/icons';
// import DocumentMeta from 'react-document-meta';
// import Head from '@iso/config/next.config';
// import { Helmet } from "react-helmet";
// import mergeImages from 'merge-images';
// import resizeImage from 'resize-image';
import netcore from '@iso/lib/helpers/netcore';
import dashboardActions from '@iso/redux/dashboard/actions';

const { setUrl, setPrevUrl } = dashboardActions;
const { fetchProductById,fetchBranch } = inventoryAction;
const { submitTempTransaction, resetTempTransactionMessage } = trxAction;
const { Title, Paragraph } = Typography;

export default function Inventory() {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const { Option } = Select;
  const redirectUrl = `${process.env.REACT_APP_REDIRECT_URL}${match.url}`;
  const [qtyForm] = Form.useForm();
  const [chargeForm] = Form.useForm();
  const [dateForm] = Form.useForm();
  const [branchForm] = Form.useForm();
  const url = useSelector((state) => state.Dashboard.url);
  const prevUrl = useSelector((state) => state.Dashboard.prevUrl);
  const redirectProductFetching = useSelector((state) => state.Inventory.redirectProductFetching);
  const redirectProduct = useSelector((state) => state.Inventory.redirectProduct);
  const branches = useSelector((state) => state.Inventory.branches);
  const fetchingBranch = useSelector((state) => state.Inventory.fetchingBranch);
  const productImages = redirectProduct && redirectProduct.inventorydetailsInfo && redirectProduct.inventorydetailsInfo.images ? JSON.parse(redirectProduct.inventorydetailsInfo.images) : null;
  const productDetails = redirectProduct && redirectProduct.inventorydetailsInfo && redirectProduct.inventorydetailsInfo.body ? JSON.parse(redirectProduct.inventorydetailsInfo.body) : null;
  const productDetailsEntries = productDetails ? Object.entries(productDetails) : null;
  const merchantSettings = redirectProduct && redirectProduct.merchantInfo && redirectProduct.merchantInfo.merchantSettings ? redirectProduct.merchantInfo.merchantSettings : null;
  // const redirectProductQr = useSelector((state) => state.Inventory.redirectProductQr);
  const redirectProductMessage = useSelector((state) => state.Inventory.redirectProductMessage);
  const redirectSubmittingTrx = useSelector((state) => state.Transactions.redirectSubmittingTrx);
  const redirectSubmittedTrx = useSelector((state) => state.Transactions.redirectSubmittedTrx);
  const redirectSubmitMessage = useSelector((state) => state.Transactions.redirectSubmitMessage);
  const [inventoryId, setInventoryId] = React.useState(null);
  const [appointmentDate, setAppointmentDate] = React.useState(null);
  const [branch, setBranch] = React.useState(null);
  const [quantity, setQuantity] = React.useState(1);
  const [additionalCharge, setAdditionalCharge] = React.useState(0);
  const [totalAmount, setTotalAmount] = React.useState('0.00');
  const [btnDisabled, setBtnDisabled] = React.useState(true);
  const [btnDisabledNbi, setBtnDisabledNbi] = React.useState(true);
  const [loading, setLoading] = React.useState(redirectProductFetching);
  const [isOnline, setNetwork] = React.useState(window.navigator.onLine);
  const [previousConnection, setPreviousConnection] = React.useState(window.navigator.onLine);
  useEffect(() => {
    // NETCORE START
    if (url !== window.location.href) {
      dispatch(setUrl(window.location.href))
    }
    
    if (url !== prevUrl) {
      netcore({type: 'activity', activityName: 'screen_load_event', activityData: {'page_url': url}})
      dispatch(setPrevUrl(url))
    }
    // NETCORE END

    if (!inventoryId && !redirectProduct && !redirectProductFetching) {
      dispatch(fetchProductById(match.params.id));
      setInventoryId(match.params.id);
      setBtnDisabled(false);
    }
    if (merchantSettings && merchantSettings.isNbi && !branches && !fetchingBranch) {
      dispatch(fetchBranch())
    }
    if (branch && appointmentDate) {
      setBtnDisabledNbi(false);
    }
    if (loading !== redirectProductFetching) {
      setLoading(redirectProductFetching);
    }

    if (redirectSubmittedTrx && !redirectSubmittingTrx && !redirectSubmitMessage && redirectSubmittedTrx.paymentLinkUrl) {
      window.location.href = redirectSubmittedTrx.paymentLinkUrl;
    }

    if (!redirectSubmittedTrx && !redirectSubmittingTrx && redirectSubmitMessage) {
      message.error({ content: redirectSubmitMessage, key: 'redirectInvKey', duration: 5 });
      dispatch(resetTempTransactionMessage());
    }

    if (redirectProduct) {
      const generateMeta = (prop, cont) => {
        const mymeta = document.createElement('meta');
        mymeta.setAttribute('property', prop);
        mymeta.content = cont;
        return mymeta
      }

      document.head.appendChild(generateMeta('og:title', redirectProduct ? redirectProduct.itemDescription : 'Item Name'))
      document.head.appendChild(generateMeta('title', redirectProduct ? redirectProduct.itemDescription : 'Item Name'))
      document.head.appendChild(generateMeta('og:description', productDetails && productDetails.description ? productDetails.description : 'Item Description'))
      document.head.appendChild(generateMeta('description', productDetails && productDetails.description ? productDetails.description : 'Item Description'))
      document.head.appendChild(generateMeta('og:type', 'website'))
      document.head.appendChild(generateMeta('og:url', redirectUrl))
      document.head.appendChild(generateMeta('og:image', redirectProduct && redirectProduct.bannerUrl ? redirectProduct.bannerUrl : null))
      document.head.appendChild(generateMeta('og:image:width', '1200'))
      document.head.appendChild(generateMeta('og:image:height', '630'))
      document.head.appendChild(generateMeta('og:image:type', 'image/jpeg'))
      document.head.appendChild(generateMeta('og:image:url', redirectProduct && redirectProduct.bannerUrl ? redirectProduct.bannerUrl : null))
      document.head.appendChild(generateMeta('og:image:secure_url', redirectProduct && redirectProduct.bannerUrl ? redirectProduct.bannerUrl : null))
      document.head.appendChild(generateMeta('og:image:secure', redirectProduct && redirectProduct.bannerUrl ? redirectProduct.bannerUrl : null))
      document.head.appendChild(generateMeta('og:site_name', redirectProduct ? redirectProduct.itemDescription : 'Item Name'))
      document.head.appendChild(generateMeta('twitter:title', redirectProduct ? redirectProduct.itemDescription : 'Item Name'))
      document.head.appendChild(generateMeta('twitter:description', productDetails && productDetails.description ? productDetails.description : 'Item Description'))
      document.head.appendChild(generateMeta('twitter:site', '@paybiz'))
      document.head.appendChild(generateMeta('twitter:image', redirectProduct && redirectProduct.bannerUrl ? redirectProduct.bannerUrl : null))
      document.head.appendChild(generateMeta('twitter:domain', 'paybiz.ph'))
      document.head.appendChild(generateMeta('twitter:card', 'summary_large_image'))
      document.head.appendChild(generateMeta('fb:app_id', '566202244047272'))
      document.head.appendChild(generateMeta('Description', productDetails && productDetails.description ? productDetails.description : 'Item Description'))
      document.head.appendChild(generateMeta('theme-color', '#5B4E8E'))

      const itemprop = document.createElement('meta');
      itemprop.itemprop = 'image';
      itemprop.content = redirectProduct && redirectProduct.bannerUrl ? redirectProduct.bannerUrl : null;
      document.head.appendChild(itemprop)

      const pageTitle = document.createElement('title');
      const pageTitleCnt = document.createTextNode(redirectProduct ? redirectProduct.itemDescription : 'Paynamics Paybiz');
      pageTitle.appendChild(pageTitleCnt);
      document.head.appendChild(pageTitle)
    }
    if (redirectProduct && Number.parseInt(totalAmount) < 1) {
      setTotalAmount(redirectProduct.itemAmount)
    }
    const updateNetwork = () => {
      setPreviousConnection(isOnline);
      setNetwork(window.navigator.onLine);
    };

    window.addEventListener("offline", updateNetwork);
    window.addEventListener("online", updateNetwork);
    return () => {
      window.removeEventListener("offline", updateNetwork);
      window.removeEventListener("online", updateNetwork);
      if (previousConnection !== isOnline) { updateNetwork() }
    };
  }, [
    inventoryId,
    dispatch,
    loading,
    redirectProductFetching,
    setLoading,
    match,
    redirectProduct,
    redirectSubmittedTrx,
    redirectSubmittingTrx,
    redirectSubmitMessage,
    productDetails,
    redirectUrl,
    previousConnection,
    isOnline,
    totalAmount,
    merchantSettings,
    branches,
    fetchingBranch,
    branch,
    appointmentDate,
    prevUrl,
    url
  ]);

  // const handleChangeQty = (e) => {
  //   let value = quantity;
  //   value = e.target.value.replace(/[^0-9]/gim, '');
  //   qtyForm.setFieldsValue({
  //     quantity: value,
  //   });

  //   let total = value ? redirectProduct.itemAmount * value : 0;
  //   total = parseFloat(parseFloat(total) + parseFloat(additionalCharge)).toFixed(2);
  //   if (redirectProduct.isUnlimited && value && value > 0) {
  //     setBtnDisabled(false);
  //   } else {
  //     if (value && value <= redirectProduct.quantity && value > 0) {
  //       setBtnDisabled(false);
  //     } else {
  //       setBtnDisabled(true);
  //     }
  //   }

  //   setQuantity(value);
  //   setTotalAmount(total);
  // };

  const handleChangeQtyNew = (e, type) => {
    let value = quantity ? parseInt(quantity) : 0;
    let total = 0;
    if (type === 'none') {
      value = e.target.value.replace(/[^0-9]/gim, '');
      qtyForm.setFieldsValue({
        quantity: value,
      });

      total = value ? redirectProduct.itemAmount * value : 0;
      total = parseFloat(parseFloat(total) + parseFloat(additionalCharge)).toFixed(2);
      if (redirectProduct.isUnlimited && value && value > 0) {
        setBtnDisabled(false);
      } else {
        if (value && value <= redirectProduct.quantity && value > 0) {
          setBtnDisabled(false);
        } else {
          setBtnDisabled(true);
        }
      }
    } else if (type === 'add') {
      if (!redirectProduct.isUnlimited) {
        if (value < redirectProduct.quantity) {
          value = value + 1;
        }
      } else {
        value = value + 1;
      }

      qtyForm.setFieldsValue({
        quantity: value,
      });

      total = value ? redirectProduct.itemAmount * value : 0;
      total = parseFloat(parseFloat(total) + parseFloat(additionalCharge)).toFixed(2);
      if (redirectProduct.isUnlimited && value && value > 0) {
        setBtnDisabled(false);
      } else {
        if (value && value <= redirectProduct.quantity && value > 0) {
          setBtnDisabled(false);
        } else {
          setBtnDisabled(true);
        }
      }
    } else if (type === 'sub') {
      if (value > 0) {
        value = value - 1;
      }
      qtyForm.setFieldsValue({
        quantity: value,
      });

      total = value ? redirectProduct.itemAmount * value : 0;
      total = parseFloat(parseFloat(total) + parseFloat(additionalCharge)).toFixed(2);
      if (redirectProduct.isUnlimited && value && value > 0) {
        setBtnDisabled(false);
      } else {
        if (value && value <= redirectProduct.quantity && value > 0) {
          setBtnDisabled(false);
        } else {
          setBtnDisabled(true);
        }
      }
    }


    setQuantity(value);
    setTotalAmount(total);
  };

  const onChangeBranch = (value) => {
    setBranch(value)
  }
  const onChangeDate = (date,dateString) => {
    setAppointmentDate(dateString)
  }
  const disabledDates = (current) => {
    // return current && current.valueOf() < Date.now();
    return current < moment().subtract('1', 'day').endOf('day');
  }
  const handleChangeCharge = (e) => {
    let value = additionalCharge;
    // eslint-disable-next-line no-useless-escape
    value = e.target.value.replace(/[^0-9\.]/gim, '');
    chargeForm.setFieldsValue({
      additionalCharge: value,
    });
    const total = redirectProduct.itemAmount * quantity;
    const finalAmount = value ? parseFloat(parseFloat(total) + parseFloat(value)).toFixed(2) : parseFloat(total).toFixed(2);  
    setAdditionalCharge(value);
    setTotalAmount(finalAmount);
  };

  const generateRandomString = () => {
    let id = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    for (let i = 0; i < 10; i++) {
      id += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return id;
  };

  const handleNext = () => {
    let arrayServiceableArea = [];
    if (redirectProduct) {
      const serveArea = redirectProduct.serviceableArea;
      arrayServiceableArea = serveArea ? serveArea.split(',') : [];
    }
    // let cusmtomMerchantParam = [];
    let appointmentDateData = null;
    let branchData = null;
    if (merchantSettings && merchantSettings.isNbi) {
      branchData = {
        system_id: 'PAYBIZ',
        field: 'branch',
        label: 'Branch',
        value: branch,
      };
      appointmentDateData = {
        system_id: 'PAYBIZ',
        field: 'appointment_date',
        label: 'Appointment Date',
        value: appointmentDate,
      };
    }
    // const totalAmountFormatted = totalAmount.toFixed(2);
    const randomId = generateRandomString();
    const data = {
      transaction: {
        request_id: `PAYLINK${randomId}`,
        notification_url: '',
        response_url: '',
        cancel_url: '',
        pmethod: 'all',
        pchannel: '',
        payment_action: 'url_link',
        collection_method: 'single_pay',
        payment_notification_status: '1',
        payment_notification_channel: '0',
        amount: totalAmount,
        currency: 'PHP',
        signature: '',
      },
      customer_info: {
        fname: '',
        lname: '',
        mname: '',
        email: '',
        phone: '',
        mobile: '',
        dob: '',
        signature: '',
      },
      billing_info: {
        billing_address1: '',
        billing_address2: '',
        billing_city: '',
        billing_state: '',
        billing_country: '',
        billing_zip: '',
      },
      order_details: {
        orders: [
          {
            itemId: redirectProduct.Id,
            itemname: redirectProduct.itemDescription,
            quantity: quantity,
            unitprice: redirectProduct.itemAmount,
            totalprice: (redirectProduct.itemAmount * quantity).toFixed(2),
            // totalprice: totalAmount,
            itemcode: redirectProduct.itemCode,
            serviceable: arrayServiceableArea,
            shippable: redirectProduct.shippable,
          },
        ],
        additionalcharges: additionalCharge,
        subtotalprice: (redirectProduct.itemAmount * quantity).toFixed(2),
        // subtotalprice: (totalAmount - additionalCharge).toFixed(2),
        shippingprice: '0.00',
        discountamount: '0.00',
        totalorderamount: totalAmount,
      },
      baranggay: '',
      storeId: redirectProduct.storeId,
      customerChoosePmethod: true,
      customerInputInfo: true,
      // cusmtomMerchantParam,
      appointmentDate: appointmentDateData,
      branch: branchData,
    };
    dispatch(submitTempTransaction(data));
  }

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      width: 80,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  let data = [];
  if (productDetailsEntries) {
    productDetailsEntries.forEach((element, index) => {
      if ((typeof element[1] !== "boolean") && element[0] !== 'item_type' && element[0] !== 'description') {
        data.push({
          title: element[0].charAt(0).toUpperCase() + element[0].slice(1),
          description: element[1],
          key: index
        });
      }
    });
  }

  let locale = {
    emptyText: (
      <span>
        <p>
          <Empty style={{ flexDirection: 'column' }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </p>
      </span>
    )
  };

  const notificationStyle = {
    width: '100%',
  };
  const networkNotification = () => {
    if (isOnline) { setPreviousConnection(isOnline) }
    notification.destroy();
    notification.info({
      message: isOnline ? 'You are back online' : 'You are currently offline.',
      placement: 'bottomLeft',
      icon: isOnline ? <WifiOutlined style={{ color: 'green' }} /> : <DisconnectOutlined />,
      duration: isOnline ? 3 : null,
      bottom: 0,
      style: notificationStyle,
    });
  };

  return (
    <InventoryWrapper>
      {isOnline ? isOnline !== previousConnection ? networkNotification() : '' : isOnline !== previousConnection ? networkNotification() : ''}
      {!loading && redirectProduct && !redirectProductMessage ?
        <div style={{ height: '100%', maxHeight: '100%' }}>
          <div className="inventoryCont">
            <div className="inventoryAvatar">
              {
                redirectProduct && redirectProduct.base64Image ?
                  // Added fix in redirect inventory
                  <img
                    src={redirectProduct.base64Image}
                    // src={headerLogo}
                    // src={mergedImageFinal}
                    alt="inventory-avatar"
                    className="inventoryImg"
                  /> :
                  <img
                    src={headerLogo}
                    alt="inventory-avatar"
                    className="inventoryImg"
                  />
              }
              {/* <h3 style={{ fontSize: '15px' }}>
                {
                  redirectProduct && redirectProduct.paymentHeader ?
                    `${redirectProduct.paymentHeader}:` : <IntlMessages id="Biz.redirect.inventory.form.header.default" />
                }
              </h3> */}
            </div>
            <div className="isoLeftRightComponent inventoryBody">
              <div className="inventoryLeft" style={{ display: productImages && productImages.length > 1 ? 'block' : 'none' }}>
                <Carousel>
                  {
                    productImages ? productImages.map((image, index) => {
                      return (
                        image.alias !== 'cover' ?
                          <img
                            key={`image_${index}`}
                            src={image.awsUrl ? image.awsUrl : null}
                            alt="inventory-avatar"
                            className="inventoryImg"
                            style={{ width: '100% !important', maxWidth: '100% !important', minWidth: '100% !important' }}
                          /> : null
                      );
                    }) : null
                  }
                </Carousel>
              </div>
              <div className="inventoryRight" style={{ margin: productImages ? '0' : '0 auto' }}>
                <Title level={1} className="itemTitle">
                  {redirectProduct ? redirectProduct.itemDescription : 'Item Name'}
                  {/* Four Seasons */}
                </Title>
                {redirectProduct && !redirectProduct.isUnlimited ?
                  <Paragraph style={{ color: redirectProduct && redirectProduct.quantity > 0 ? '#3FB65F' : '#f64744' }}>
                    {redirectProduct ? redirectProduct.quantity > 0 ? `${redirectProduct.quantity} available` : `OUT OF STOCK` : ''}
                  </Paragraph> : ''
                }
                <Title level={3} className="itemPrice">
                  {redirectProduct ? `₱ ${redirectProduct.itemAmount}` : '₱ 0.00'}
                  {/* ₱ 30.00 */}
                </Title>
                <Paragraph ellipsis={{ rows: 3, expandable: true, symbol: 'more' }} style={productDetails && productDetails.description ? null : { color: '#666666', textAlign: 'center', fontStyle: 'italic' }}>
                  {/* Freshly extracted juice from mango, orange, pineapple, and guava. A blend of different fruit flavors that will surely quench your thirst. A sip can take you to four seasons of the year - pineapple (summer), orange (fall), guava (winter), and mango (spring). This drink is so good you could wish this is not a demo product. */}
                  {productDetails && productDetails.description ? productDetails.description : 'No details available'}
                </Paragraph>
                 {/* BRANCH */}
                 {merchantSettings && merchantSettings.isNbi ?
                  <div>
                    <div style={{marginBottom: '10px'}}>
                      <Form
                        form={branchForm}
                        name="chargeForm"
                      >
                        <div className="wrapper-charge">
                          <Form.Item
                            name="additionalCharge"
                            onChange={(e) => handleChangeCharge(e)}
                            style={{ marginBottom: '0px' }}
                            rules={[
                              {
                                  required: true,
                                  message: 'Please select Branch!',
                              },
                              ({ getFieldValue }) => ({
                                  validator(rule, value) {
                                      if (!value) {
                                          return Promise.resolve();
                                      }
                                  },
                              }),
                            ]}
                          >
                            
                            <Select
                                size="large"
                                disabled={fetchingBranch || redirectSubmittingTrx}
                                placeholder="Select Branch"
                                style={{ width: '100%' }}
                                onSelect={(value) => onChangeBranch(value)}
                                showSearch
                                autoComplete="dont-use-autocomplete"
                                // autoComplete="chrome-off"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {
                                    branches ? branches.map((branch, index) => {
                                        return <Option key={`province-billing-${index}`} value={branch.branchName}>{branch.branchName}</Option>
                                    }) : null
                                }
                            </Select>
                          </Form.Item>
                        </div>
                        </Form>
                      </div>
                      {/* APPOINTMENT DATE */}
                      <div>
                        <Form
                          form={dateForm}
                          name="chargeForm"
                        >

                          <div className="wrapper-charge">
                            <Form.Item
                              name="date"
                              style={{ marginBottom: '0px' }}
                              rules={[
                                {
                                    required: true,
                                    message: 'Please select Appointment Date!',
                                },
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (!value) {
                                            return Promise.resolve();
                                        }
                                    },
                                }),
                              ]}
                            >
                                <DatePicker
                                  size="large"
                                  onChange={onChangeDate}
                                  disabledDate={disabledDates}
                                  disabled={fetchingBranch || redirectSubmittingTrx}
                                  style={{ width: '100%' }}
                                  // showTime={true}
                                />
                            </Form.Item>
                          </div>
                          </Form>
                      </div>
                  </div>
                 : null}
                {data && data.length > 0 ?
                  <Table style={{ marginBottom: '1em' }} showHeader={false} loading={false} columns={columns} dataSource={data ? data : null} locale={locale} pagination={false} size="middle" />
                  : null}
                <div className="isoLeftRightComponent">
                  {merchantSettings && !merchantSettings.isNbi ?
                    <div className="inventoryLeftBottom">
                      <Form
                        form={qtyForm}
                        name="qtyForm"
                      >
                        Quantity:
                        <div className="wrapper">
                          <Button className="plusminus" onClick={(e) => handleChangeQtyNew(e, 'sub')}>-</Button>
                          <Form.Item
                            name="quantity"
                            onChange={(e) => handleChangeQtyNew(e, 'none')}
                            initialValue={1}
                          >
                            <Input
                              className="num"
                              size="medium"
                            // style={{ borderRadius: '5px' }}
                            />
                          </Form.Item>
                          <Button className="plusminus" onClick={(e) => handleChangeQtyNew(e, 'add')}>+</Button>
                        </div>
                        <Paragraph className="maxQtyMessage">
                          {!redirectProduct.isUnlimited ? quantity && parseInt(quantity) > parseInt(redirectProduct.quantity) ? `Max quantity reach! (${redirectProduct.quantity})` : '' : ''}
                        </Paragraph>
                      </Form>
                    </div>
                  : null}
                  {redirectProduct.additionalCharge && merchantSettings && !merchantSettings.isNbi ?
                    <div className="inventoryRightBottom">
                      <Form
                        form={chargeForm}
                        name="chargeForm"
                      >
                        Additional Charges:
                        <div className="wrapper-charge">
                          <Form.Item
                            name="additionalCharge"
                            onChange={(e) => handleChangeCharge(e)}
                            style={{ marginBottom: '0px' }}
                          >
                            <Input
                              size="medium"
                              prefix="₱"
                              style={{ border: 'none', boxShadow: 'none' }}
                            // style={{ borderRadius: '5px' }}
                            />
                          </Form.Item>
                        </div>
                        <Paragraph className="maxQtyMessage">

                        </Paragraph>
                      </Form>
                    </div> : ''}
                </div>
                {merchantSettings && merchantSettings.isNbi ?
                <div className="isoLeftRightComponent">
                  <div style={{ display: 'block' }}></div>
                  <Button
                    type="primary"
                    className="nextButtonNbi"
                    size="medium"
                    disabled={btnDisabledNbi || redirectSubmittingTrx}
                    onClick={() => handleNext()}
                    loading={redirectSubmittingTrx}
                  >
                    Set Appointment
                  </ Button>
                </div>
                :
                <div className="isoLeftRightComponent">
                  <div style={{ display: 'block' }}></div>
                  <Button
                    type="primary"
                    className="nextButton"
                    size="medium"
                    disabled={btnDisabled || redirectSubmittingTrx}
                    onClick={() => handleNext()}
                    loading={redirectSubmittingTrx}
                  >
                    Buy Now
                  </ Button>
                </div>
                }
              </div>
            </div>
            {/* <div className="inventoryBody">
              <div className="detailsTitle">
                <IntlMessages id="Biz.redirect.inventory.form.orderSummary.label.uppercase" />
              </div>
              <Spin spinning={redirectSubmittingTrx} tip={<IntlMessages id="Biz.dialog.button.Loading" />}>
                <TransactionListItem
                  // itemLabelLeft={redirectProduct ? redirectProduct.itemDescription : <IntlMessages id="Biz.redirect.inventory.form.itemName.label" />}
                  itemLabelLeft={redirectProduct ? redirectProduct.itemDescription : 'Item Name'}
                  size="normal"
                  // itemLabelRight={redirectProduct ? `PHP ${redirectProduct.itemAmount}` : <IntlMessages id="Biz.redirect.inventory.form.itemAmount.default" />}
                  itemLabelRight={redirectProduct ? `PHP ${redirectProduct.itemAmount}` : 'PHP 0.00'}
                  labelRightStyle={{ fontWeight: 'normal' }}
                />
                <TransactionListItem
                  size="normal"
                  // itemLabelLeft={<IntlMessages id="Biz.redirect.inventory.form.qtyToOrder.label"/>}
                  itemLabelLeft="Enter quantity to order:"
                  itemLabelRight={
                    <div className="itemActions">
                      <Form
                        form={qtyForm}
                        name="qtyForm"
                      >
                        <div className="isoInputWrapper isoLeftRightComponent" style={{ alignItems: 'flex-start' }}>
                          <Form.Item
                            name="quantity"
                            onChange={(e) => handleChangeQty(e)}
                            rules={[
                              ({ getFieldValue }) => ({
                                validator(rule, value) {
                                  if (!value) {
                                    return Promise.resolve();
                                  }
                                  const inStock = redirectProduct.isUnlimited ? true : parseInt(value) <= parseInt(redirectProduct.quantity);
                                  if (inStock) {
                                    return Promise.resolve();
                                  } else {
                                    return Promise.reject(
                                      `Max quantity reach! (${redirectProduct.quantity})`
                                    );
                                  }
                                },
                              }),
                            ]}
                          >
                            <Input
                              size="medium"
                              style={{ borderRadius: '5px' }}
                            />
                          </Form.Item>
                        </div>
                      </Form>
                    </div>}
                  labelLeftStyle={{ margin: 'auto 0 !important' }}
                />
                {redirectProduct.additionalCharge ?
                  <TransactionListItem
                    size="normal"
                    // itemLabelLeft={<IntlMessages id="Biz.redirect.inventory.form.additionalCharges.label"/>}
                    itemLabelLeft="Additional Charges"
                    itemLabelRight={
                      <div className="itemActions">
                        <Form
                          form={chargeForm}
                          name="chargeForm"
                        >
                          <div className="isoInputWrapper isoLeftRightComponent" style={{ alignItems: 'flex-start' }}>
                            <Form.Item
                              name="additionalCharge"
                              onChange={(e) => handleChangeCharge(e)}
                            >
                              <Input
                                size="medium"
                                prefix="₱"
                                style={{ borderRadius: '5px' }}
                              />
                            </Form.Item>
                          </div>
                        </Form>
                      </div>}
                    labelLeftStyle={{ margin: 'auto 0 !important' }}
                  /> : ''}
                <TransactionListItem
                  // itemLabelLeft={<IntlMessages id="Biz.redirect.inventory.form.total.label.uppercase"/>}
                  itemLabelLeft="TOTAL"
                  size="large"
                  strong
                  noBorder
                  itemLabelRight={`₱ ${totalAmount}`}
                />
              </Spin>
              <Button
                type="primary"
                className="nextButton"
                size="large"
                disabled={btnDisabled || redirectSubmittingTrx}
                // loading={isDownloadQrPdf}
                // icon={<QrIcon />}
                onClick={() => handleNext()}
              >
                <IntlMessages id="Biz.dialog.button.Next.Uppercase" />
              </ Button>
            </div> */}
            <div className="inventoryFooter">
              <div className="isoInputWrapper isoLeftRightComponent footerContainer">
                <div className="footerText">
                  <IntlMessages id="Biz.redirect.inventory.footer.poweredBy" /> <br />
                  <IntlMessages id="Biz.redirect.inventory.footer.company" /> <br />
                  <IntlMessages id="Biz.redirect.inventory.footer.copyright" /> &copy; <IntlMessages id="Biz.redirect.inventory.footer.year" />
                  {/* Paybiz is powered by <br />Paynamics Technologies Inc. <br /> Copyright &copy; 2021 */}
                </div>
                <img src={footerLogo} alt="footer" />
              </div>
            </div>
          </div>
        </div>
        : !loading && !redirectProduct && redirectProductMessage ?
          redirectProductMessage !== 'Item not found!' ? <ErrorHolder message={redirectProductMessage} /> :
            <ItemNotFound message={redirectProductMessage} /> :
          <div className="inventoryLoading">
            <img
              src={loadingLogo}
              alt="loading-logo"
              className="loadingLogo"
            />
          </div>
      }
    </InventoryWrapper>
  );
}
